import { FlaskConical, Gauge, Moon, Tag, User, Wrench } from "lucide-react";
import { cn } from "@/lib/utils";

// The badge says at a glance what kind of job this is: nightly (scheduled),
// tag (release qualification), manual (run by hand), and the Trigger page's
// mctest / cryod-test / perf. Colors are kind-identity, distinct from status.
const TRIGGER_STYLES = {
  nightly: {
    icon: Moon,
    label: "nightly",
    className: "bg-indigo-500/10 text-indigo-500 border-indigo-500/30",
  },
  tag: {
    icon: Tag,
    label: "release",
    className: "bg-purple-500/10 text-purple-500 border-purple-500/30",
  },
  manual: {
    icon: User,
    label: "manual",
    className: "bg-muted text-muted-foreground border-border",
  },
  mctest: {
    icon: FlaskConical,
    label: "mooncake test",
    className: "bg-cyan-500/10 text-cyan-500 border-cyan-500/30",
  },
  "cryod-test": {
    icon: Wrench,
    label: "cryod test",
    className: "bg-teal-500/10 text-teal-500 border-teal-500/30",
  },
  perf: {
    icon: Gauge,
    label: "perf",
    className: "bg-orange-500/10 text-orange-500 border-orange-500/30",
  },
} as const;

export function TriggerBadge({
  trigger,
  releaseTag,
}: {
  trigger: string;
  releaseTag?: string | null;
}) {
  const style = TRIGGER_STYLES[trigger as keyof typeof TRIGGER_STYLES] ?? TRIGGER_STYLES.manual;
  const Icon = style.icon;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium",
        style.className,
      )}
    >
      <Icon className="h-3 w-3" />
      {style.label}
      {trigger !== "nightly" && trigger !== "manual" && releaseTag ? (
        <span className="font-mono">{releaseTag}</span>
      ) : null}
    </span>
  );
}
